import { render, staticRenderFns } from "./XhCustomerAddress.vue?vue&type=template&id=6094345c&scoped=true"
import script from "./XhCustomerAddress.vue?vue&type=script&lang=js"
export * from "./XhCustomerAddress.vue?vue&type=script&lang=js"
import style0 from "./XhCustomerAddress.vue?vue&type=style&index=0&id=6094345c&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6094345c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6094345c')) {
      api.createRecord('6094345c', component.options)
    } else {
      api.reload('6094345c', component.options)
    }
    module.hot.accept("./XhCustomerAddress.vue?vue&type=template&id=6094345c&scoped=true", function () {
      api.rerender('6094345c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhCustomerAddress.vue"
export default component.exports